import { useEffect, useState } from 'react';

/**
 * Local (client-side) filter state for a table's collapsible filter bar.
 * Clears back to `emptyFilters` whenever `isOpen` goes false, so closing
 * the filter bar always returns the table to its unfiltered state.
 * @param {object} emptyFilters - stable (module-level) empty filters shape
 * @param {boolean} isOpen
 */
const useLocalTableFilters = (emptyFilters, isOpen) => {
    const [filters, setFilters] = useState(emptyFilters);

    useEffect(() => {
        if (!isOpen) setFilters(emptyFilters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    const handleFilterChange = (key, value) =>
        setFilters(prev => ({ ...prev, [key]: value }));
    const handleResetFilters = () => setFilters(emptyFilters);
    const hasActiveFilters = Object.values(filters).some(Boolean);

    return { filters, handleFilterChange, handleResetFilters, hasActiveFilters };
};

export default useLocalTableFilters;
